export const OrderLookupSource = {
    OID: 'OID',
    OI: 'OI',
    CE: 'CE',
} as const;
export type OrderLookupSource = typeof OrderLookupSource[keyof typeof OrderLookupSource];

export const OrderLookupSourceLabel: Record<OrderLookupSource, string> = {
    OID: 'Order Insight Digital',
    OI: 'Order Insight',
    CE: 'Compelling Evidence',
};

export const OrderInsightMatchStatus = {
    MATCHED: 'matched',
    NOT_FOUND: 'not_found',
    MULTIPLE_MATCHES: 'multiple_matches',
    NO_TRANSACTION_SOURCE: 'no_transaction_source',
    UNMAPPED_MERCHANT: 'unmapped_merchant',
    MISSING_MERCHANT_INFO: 'missing_merchant_info',
    ERROR: 'error',
} as const;
export type OrderInsightMatchStatus = typeof OrderInsightMatchStatus[keyof typeof OrderInsightMatchStatus];

export const OrderInsightMatchStatusLabel: Record<OrderInsightMatchStatus, string> = {
    matched: 'Matched',
    not_found: 'Transaction Not Found',
    multiple_matches: 'Multiple Transactions Found',
    no_transaction_source: 'No Transaction Source',
    unmapped_merchant: 'Configuration Error: Unmapped Merchant',
    missing_merchant_info: 'Configuration Error: Missing Merchant Info',
    error: 'Error',
};

// Deflection outcome for the linked CE_NOTICE, derived from its case_event:
// NEW => deflected, FAILED => failed. Other / no linked notice => plain lookup.
export const OrderInsightDeflectionOutcome = {
    DEFLECTED: 'deflected',
    FAILED: 'failed',
} as const;
export type OrderInsightDeflectionOutcome = typeof OrderInsightDeflectionOutcome[keyof typeof OrderInsightDeflectionOutcome];

export const OrderInsightDeflectionOutcomeLabel: Record<OrderInsightDeflectionOutcome, string> = {
    deflected: 'Deflected',
    failed: 'Failed',
};

export function deflectionOutcome(caseEvent: string | null): OrderInsightDeflectionOutcome | null {
    if (caseEvent === 'NEW') return OrderInsightDeflectionOutcome.DEFLECTED;
    if (caseEvent === 'FAILED') return OrderInsightDeflectionOutcome.FAILED;
    return null;
}

export interface OrderInsightRow {
    verifi_order_insight_id: number;
    insight_id: string;
    source: OrderLookupSource;
    transaction_request_id: string | null;
    linked_insight_id: string | null;
    payment_descriptor: string | null;
    acquirer_bin: string | null;
    card_acceptor_id: string | null;
    card_bin: string | null;
    card_last4: string | null;
    auth_code: string | null;
    transaction_id: string | null;
    arn: string | null;
    transaction_date: string | null;
    transaction_amount: number | null;
    transaction_currency: string | null;
    pp_type: string | null;
    pp_account_id: number | null;
    company_id: number | null;
    match_status: OrderInsightMatchStatus;
    http_status: number;
    latency_ms: number | null;
    response_payload: Record<string, unknown> | null;
    received_at: string;
    company_name: string | null;
    merchant_name: string | null;
    is_staging: boolean;
    deflection_event: string | null;
    deflection_case_id: string | null;
}

export interface OrderInsightListResponse {
    rows: OrderInsightRow[];
    pagination: {
        currentPage: number;
        totalPages: number;
        totalItems: number;
        itemsPerPage: number;
        hasNextPage: boolean;
        hasPrevPage: boolean;
    };
}

export interface OrderInsightMerchant {
    merchant_id: number;
    merchant_name: string | null;
}

export interface OrderInsightMerchantListResponse {
    merchants: OrderInsightMerchant[];
}
